import { render, staticRenderFns } from "./ConfiguracionCajas.vue?vue&type=template&id=156d3f9a&scoped=true"
import script from "./ConfiguracionCajas.vue?vue&type=script&lang=js"
export * from "./ConfiguracionCajas.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionCajas.vue?vue&type=style&index=0&id=156d3f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156d3f9a",
  null
  
)

export default component.exports